module.exports = __webpack_public_path__ + "static/img/14000553.9a131146.png";